import React, { useEffect } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import PageHeader from '../components/PageHeader';
import TourSearch from '../components/TourSearch';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import SEO from '../components/SEO';

const PageContainer = styled.div`
  background-color: #ededed;
  min-height: 100vh;
`;

const TourSearchPage = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <SEO 
        title="Подбор тура онлайн | Максимум Тур - Турагентство во Владивостоке"
        description="Онлайн подбор туров по всему миру от турагентства Максимум Тур во Владивостоке. Найдите идеальный тур с помощью нашего поисковика. Горящие туры и лучшие цены."
        keywords="подбор тура, поиск тура, купить тур, туроператор, горящие туры, путевки, отдых, Максимум Тур"
        type="website"
      />
      <Menu />
      <Header />
      <PageHeader />
      <TourSearch />
      <ContactForm />
      <Footer />
    </PageContainer>
  );
};

export default TourSearchPage;